/*************** Serach Form Js Start *************/

var searchlink = $('.serach_form .searh_link');
var closeform = $('.serach_form .icon-close');
$(document).ready(function(){
  
  searchlink.click(function(event){
    event.preventDefault();
    $(this).parents('.serach_form').find('.top_bar_search').toggleClass("form_open");
   
  });
  closeform.click(function(event){
    $(this).parents('.serach_form').find('.top_bar_search').removeClass("form_open");
   
  });
});

/*************** Serach Form Js End *************/

/******* Blacklist Query Based Url Words Code Start  ***********/
if (window.location.search !== '' && window.location.search !== '?') {

    const params = new URLSearchParams(window.location.search);

    let queries = {};

    for(var value of params.keys()) {

         queries[value] = params.get(value);

    }

    let blacklist_words = [

      "vendors", "xbox", "coins", "ps4", "ps5", "gems", "xbox one", "diablo", "power leveling",
      "lootboy", "adena"

    ];

    for (const [key, value] of Object.entries(queries)) {

        if (

            (/[^\x00-\x7F]+/.test( value ) && key === 'q') ||

            (/[^\x00-\x7F]+/.test( value ) && key === 'search_query') ||

            (/[^\x00-\x7F]+/.test( value ) && key === 's') ||

            (blacklist_words.length && blacklist_words.includes(value))

        ) {

            window.location.href = window.location.href.split('?')[0]

        }

    }

}

/******* Blacklist Query Based Url Words Code End  ***********/

/************** Sticky Add To Cart JS Start ******************/
var addToCartoffset = $('.template-product .product_section button.add_to_cart').offset().top;
console.log(addToCartoffset);
$(window).scroll(function() {
 if ($(window).scrollTop() > addToCartoffset){
$('body').addClass("sticky-add-to-cart");
   } else {
      $('body').removeClass("sticky-add-to-cart");
   }
});
/************** Sticky Add To Cart JS End ******************/